@if (isLoading) {
  <div style="padding-top: 120px;">
    <div class="spinner"></div>
  </div>
}
@if (!isLoading) {
  <div style="display: flex; flex-direction: column; justify-content: center;">
    <h1 style="display: flex; justify-content: center;">
      <span>{{downloadMessage}}</span>
    </h1>
  </div>
}